export const chatBoxFileAccept = new Map<string, string[]>([
  ['image/*', []],
  ['text/plain', ['.txt']],
  ['application/pdf', ['.pdf']],
  ['application/vnd.ms-excel', ['.xls']],
  ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', ['.xlsx']],
])
